// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmark-icon{stroke:#344048;stroke-width:1px;fill:none;width:19px;height:26px}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/svg/bookmark-icon.vue","webpack://./assets/src/styles/config/_colors.scss"],"names":[],"mappings":"AAIA,eACC,cCec,CDdd,gBAAA,CACA,SAAA,CACA,UAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
